import React from 'react';
import { LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type SectionCTAProps = {
  label: string;
  dark?: boolean;
};
export function SectionCTA({
  label,
  dark = false
}: SectionCTAProps) {
  return <div className="mt-12 flex flex-col items-center gap-3 md:mt-14" data-id="element-289" data-mp="1lcbhxs1gufbm">
      <CTAButton label={label} data-id="element-290" data-mp="1qb4xrr486iey" />
      <p className={`flex items-center gap-1.5 text-sm font-medium ${dark ? 'text-navy-100/80' : 'text-muted'}`} data-id="element-291" data-mp="1qad10cyw6en3">
        <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-292" data-mp="1gdi5m2xx0ud1" />
        $27 one-time · Immediate digital access
      </p>
    </div>;
}